import type { QueryClient } from "@tanstack/react-query";

/**
 * Keeps an unobserved intent prefetch alive long enough for the intended UI to mount.
 *
 * A zero `gcTime` removes a completed prefetch before a later click can consume it,
 * while the app-wide ten-minute default would keep a live Convex watch far too long.
 */
export const INTENT_PREFETCH_GC_TIME_MS = 15_000;

/**
 * Bounds speculative query cache entries without shortening normal navigation cache lifetimes.
 */
export function getIntentPrefetchQueryOptions(preload: boolean): {
  gcTime?: number;
} {
  return preload ? { gcTime: INTENT_PREFETCH_GC_TIME_MS } : {};
}

/** Old views must not keep live watches under the next account or workspace. */
export function removeInactiveConvexQueries(queryClient: QueryClient): void {
  queryClient.removeQueries({
    predicate: (query) =>
      query.queryKey[0] === "convexQuery" && query.getObserversCount() === 0,
  });
}
